export function scrollingMessageDurationSeconds(message: string): number {
  const length = message.trim().length;
  return Math.max(8, Math.min(30, length * 0.225));
}
